import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';

type Props = {
    expertise: string;
    id: number;
    imgSrc: string;
    name: string;
};

export const Curator = ({ expertise, id, imgSrc, name }: Props) => (
    <div
        className="flex flex-col items-center"
        key={id}
    >
        <div className="relative mb-xs flex h-[140px] w-[140px] items-center justify-center overflow-hidden rounded-full">
            <img
                alt={name}
                className="max-h-full max-w-full contain-content"
                height={140}
                src={imgSrc}
                width={140}
            />
        </div>
        <div className="flex w-full flex-col items-center justify-around text-center">
            <H5>{name}</H5>
            <BodySecondary color="secondary">{expertise}</BodySecondary>
        </div>
    </div>
);
